import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { mapAsBody } from '../app/shared/util/request-util';
import { ISalesSupportActions } from '../models/sales-support-actions.model';

@Injectable({ providedIn: 'root' })
export class SalesSupportActionsService {
  readonly #apiProvider = inject(ApiProviderService);

  public post(salesSupportActions: ISalesSupportActions): Observable<ISalesSupportActions> {
    return this.#apiProvider.post<ISalesSupportActions>('/sales-support-actions', salesSupportActions).pipe(mapAsBody);
  }
}
